import React from 'react';
import ReactDOM from 'react-dom';

import './shared/global.scss';
import App from './containers/app/App';

//import * as serviceWorker from './shared/serviceWorker';
//import swConfig from './shared/swConfig';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.register(swConfig);
